import { render, staticRenderFns } from "./cube_2.vue?vue&type=template&id=14c510c9&scoped=true&"
import script from "./cube_2.vue?vue&type=script&lang=js&"
export * from "./cube_2.vue?vue&type=script&lang=js&"
import style0 from "./cube_2.vue?vue&type=style&index=0&id=14c510c9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c510c9",
  null
  
)

export default component.exports